import { useTranslation } from 'react-i18next';

type Props = {
  licenseCount: number;
  groupMemberCount: { member: number; guest: number };
};

export const GroupLicenseUsage: React.FC<Props> = ({ licenseCount, groupMemberCount }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="ml-4 border-2 border-slate-300 bg-gray-100 p-2">
      <div className="flex">
        <div className="min-w-40">{t('group.licenseUsage.licenseCount')}</div>
        <div className="min-w-20 text-right">
          {groupMemberCount.member} / {licenseCount}
        </div>
      </div>
      <div className="flex">
        <div className="min-w-40">{t('group.licenseUsage.guestLicenseCount')}</div>
        <div className="min-w-20 text-right">
          {groupMemberCount.guest} / {licenseCount}
        </div>
      </div>
    </div>
  );
};
